module.exports = "/_next/static/images/699c00f6eec369b81c57b0d4cda4c62c-hero-variant-b-desktop.jpg.webp";